import React, { useCallback } from "react";
import dayjs, { ManipulateType } from "dayjs";
import { Base } from "../../framework/base";
import Button, { ButtonProps } from "@mui/material/Button";
import { useTranslation } from "react-i18next";

export enum ShortcutOption {
    PreviousWeek = "previousWeek",
    NextWeek = "nextWeek",
    PreviousMonth = "previousMonth",
    NextMonth = "nextMonth",
}

interface DateRangeShortcutButtonProps {
    option: ShortcutOption;
    dateRange: [string, string];
    setDateRange: (val: [string, string]) => void;
    size?: ButtonProps["size"];
}

const getUnit = (option: ShortcutOption): ManipulateType =>
    [ShortcutOption.PreviousMonth, ShortcutOption.NextMonth].includes(option)
        ? "month"
        : "week";

export const DateRangeShortcutButton = ({
    option,
    dateRange,
    setDateRange,
    size
}: DateRangeShortcutButtonProps) => {
    const { t } = useTranslation();

    const handleClick = useCallback(() => {
        const isPrevious = [
            ShortcutOption.PreviousMonth,
            ShortcutOption.PreviousWeek,
        ].includes(option);

        const unit = getUnit(option);

        const start = Base.dateAdd(
            dayjs((isPrevious ? dateRange[0] : dateRange[1]) ?? new Date()),
            isPrevious ? -1 : 1,
            unit
        ).startOf(unit);

        const end = start.endOf(unit);

        setDateRange([Base.dayjsToJsonDate(start), Base.dayjsToJsonDate(end)]);
    }, [option, setDateRange]);

    return (
        <Button size={size} variant="outlined" onClick={handleClick}>
            {t(`common.datePickerShortCut.${option}`)}
        </Button>
    );
};
